module.exports = "/_next/static/images/bd40c352f635aa5835ec3ac6d208984a-WhatIsNuPlaca.png.webp";